// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  stage: 'dev',
  //old firebase config
  // firebase: {
  //   apiKey: 'AIzaSyBaFtRizEmhxUDOMP8aKO-l88h6_kSARSU',
  //   authDomain: 'salon-market-290016.firebaseapp.com',
  //   databaseURL: 'https://salon-market-290016.firebaseio.com',
  //   projectId: 'salon-market-290016',
  //   storageBucket: 'salon-market-290016.appspot.com',
  //   messagingSenderId: '659787711647',
  //   appId: '1:659787711647:web:b1de4cd208ffd8596c0eaa',
  //   measurementId: 'G-NSLWT02CFQ',
  // },

  //new firebase config
  firebase: {
    apiKey: "AIzaSyCxYFwX7AwnwjQvJ5j5fooLIRZVqtiq-Cs",
    authDomain: "lookzup-platform.firebaseapp.com",
    projectId: "lookzup-platform",
    storageBucket: "lookzup-platform.appspot.com",
    messagingSenderId: "745206404840",
    appId: "1:745206404840:web:a1c513a098bf0954cedb5d",
    measurementId: "G-PHXBBNY951",
  },
  businessImageBaseUrl:
    "https://storage.googleapis.com/salon-market_entity_uploads/",
  businessImageThumbBaseUrl:
    "https://storage.googleapis.com/salon-market_entity_uploads/thumb/",
  profileImageBaseUrl:
    "https://storage.googleapis.com/salon-market_profile_photos/",
  profileImageThumbBaseUrl:
    "https://storage.googleapis.com/salon-market_profile_photos/thumb/",

  //new urls
  apiUserServiceBaseUrl: "https://user-services.lookzup.com/dev",
  apiCommonServiceBaseUrl: "https://common-services.lookzup.com/dev",
  apiTransactionServiceBaseUrl: "https://transaction-services.lookzup.com/dev",
  apiSocialServiceBaseUrl: "https://social-services.lookzup.com/dev",
  apiUploadServiceBaseUrl: "https://upload-services.lookzup.com/dev",
  apiBusinessServiceBaseUrl: "https://business-services.lookzup.com/dev",
  apiAdminServiceBaseUrl: "https://admin-services.lookzup.com/dev",

  // old urls
  //   apiUserServiceBaseUrl:
  //   'https://user-services-dot-salon-market-290016.el.r.appspot.com/dev',
  // apiCommonServiceBaseUrl:
  //   'https://common-services-dot-salon-market-290016.el.r.appspot.com/dev',
  // apiTransactionServiceBaseUrl:
  //   'https://transaction-services-dot-salon-market-290016.el.r.appspot.com/dev',
  // apiSocialServiceBaseUrl:
  //   'https://social-services-dot-salon-market-290016.el.r.appspot.com/dev',
  // apiUploadServiceBaseUrl:
  //   'https://upload-services-dot-salon-market-290016.el.r.appspot.com/dev',
  
  razorpayKey: "rzp_test_k1DFmceaZmTGn8",
  apiFcmServiceBaseUrl:
    "https://us-central1-salon-market-290016.cloudfunctions.net",

  base_lookzup_web_url: "https://lookzup-platform-dev.web.app",
  base_lookzup_market_website_url: "https://lookzup-market-dev.web.app",
  base_lookzup_market_mobile_website_url: "https://lookzup-market-mobile-dev.web.app",
  base_lookzup_business_url: "https://lookzup-business-dev.web.app",

  base_api_url: "https://service.lookzup.com",
  cookie_hex_key: "1dfd577098c6d03f442535c4b15d3a822993eb77ca915955e77c2804ea546bde",
   paypal_client_id: "AX2wHRKRFN_QgDMpUYYUczS2ZRrFAfJTLkzikSyA1ksXnRAcea6pnN2j0DB7urtJ7itrELGnOLjsiHov",
  paypal_merchant_id: "YLJZV5VAX3NZ4",
  app_type: 'android',
  app_name: 'business',
  current_version: '2.7.0'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
